var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-task-order-detail',{staticClass:"pt-task-order-detail__withData",attrs:{"id":_vm.id,"data":_vm.data,"bill":_vm.bill},on:{"reload":_vm.getTaskDetail}})
}
var staticRenderFns = []

export { render, staticRenderFns }